import { createContext } from "react"
import { defaultReferencesContextValue } from "./defaultReferencesContextValue"
import type { ReferencesContextValue } from "./ReferencesContextValue"

export const ReferencesContext = createContext<ReferencesContextValue>(
  defaultReferencesContextValue,
)
